import React, { useEffect, useState } from "react";
import { Table, Dropdown, Menu, Input, Select } from "antd";
import { BsThreeDots } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import Instance from "../../AxiosConfig";
import AddVendorModal from "./AddVendor";
import EditVendorModal from "./EditVendor";
import DeleteVendorModal from "./DeleteVendorModal";
import ViewVendorModal from "./ViewVendor";

const { Option } = Select;

const VendorTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [gstFilter, setGstFilter] = useState("");
  const [businessFilter, setBusinessFilter] = useState("");

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleModalClick = (key, record) => {
    setSelectedData(record);

    if (key === "view") setShowViewModal(true);
    else if (key === "edit") setShowEditModal(true);
    else if (key === "delete") setShowDelete(true);
  };

  const menu = (record) => (
    <Menu onClick={({ key }) => handleModalClick(key, record)}>
      <Menu.Item key="view">View</Menu.Item>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
    </Menu>
  );

  // ✅ Fetch Vendors
  const fetchData = async () => {
    // setLoading(true);
    // try {
    //   const response = await Instance.get("/vendors");

    //   if (response.status === 200 || response.status === 201) {
    //     setData(response?.data?.vendors || []);
    //     setFilteredData(response?.data?.vendors || []);
    //   }
    // } catch (error) {
    //   console.log(error);
    // } finally {
    //   setLoading(false);
    // }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Apply Filters + Search
  useEffect(() => {
    let temp = [...data];

    // Search
    if (searchText) {
      temp = temp.filter((item) =>
        [item.vendorName, item.email, item.mobile]
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
    }

    // GST Filter
    if (gstFilter) {
      temp = temp.filter((item) => item.gst === gstFilter);
    }

    // Business Filter
    if (businessFilter) {
      temp = temp.filter(
        (item) => item.businessName === businessFilter
      );
    }

    setFilteredData(temp);
  }, [searchText, gstFilter, businessFilter, data]);

  // Unique values for filters
  const uniqueGST = [...new Set(data.map((d) => d.gst).filter(Boolean))];
  const uniqueBusiness = [
    ...new Set(data.map((d) => d.businessName).filter(Boolean)),
  ];

  // ✅ Table Columns
  const columns = [
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      render: (text) => text || "-",
    },
    {
      title: "Business Name",
      dataIndex: "businessName",
      render: (text) => text || "-",
    },
    {
      title: "Contact Person",
      dataIndex: "contactPerson",
      render: (text) => text || "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => text || "-",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      render: (text) => text || "-",
    },
    {
      title: "GST",
      dataIndex: "gst",
      render: (text) => text || "-",
    },
    {
      title: "PAN",
      dataIndex: "pan",
      render: (text) => text || "-",
    },
    {
      title: "Address",
      dataIndex: "address",
      render: (text) =>
        text ? text.substring(0, 30) + "..." : "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown overlay={menu(record)} trigger={["click"]}>
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      <div className="agents-page mt-5">
        <div className="agents-table mt-3">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="agents-heading-h1">Vendors List</h1>
            <button className="surve-export-btn" onClick={handleShow}>
              <FaPlus /> Add New Vendor
            </button>
          </div>

          {/* 🔍 Filters + Search */}
          <div className="d-flex gap-3 mt-3 flex-wrap">

            <Input
              placeholder="Search by name, email, mobile"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
              allowClear
            />

            <Select
              placeholder="Filter by GST"
              value={gstFilter || undefined}
              onChange={(val) => setGstFilter(val)}
              allowClear
              style={{ width: 200 }}
            >
              {uniqueGST.map((gst) => (
                <Option key={gst} value={gst}>
                  {gst}
                </Option>
              ))}
            </Select>

            <Select
              placeholder="Filter by Business"
              value={businessFilter || undefined}
              onChange={(val) => setBusinessFilter(val)}
              allowClear
              style={{ width: 220 }}
            >
              {uniqueBusiness.map((b) => (
                <Option key={b} value={b}>
                  {b}
                </Option>
              ))}
            </Select>

          </div>

          {/* Table */}
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={filteredData}
              rowKey="_id"
              loading={loading}
              pagination={{
                pageSize: itemsPerPage,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
              }}
              scroll={{ x: "max-content" }}
            />
          </div>

        </div>
      </div>

      {/* Modals */}
      <AddVendorModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        fetchData={fetchData}
      />

      <ViewVendorModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        vendorData={selectedData}
      />

      <EditVendorModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        vendorData={selectedData}
        fetchData={fetchData}
      />

      <DeleteVendorModal
        show={showDelete}
        onClose={() => setShowDelete(false)}
        vendorData={selectedData}
        fetchData={fetchData}
      />
    </div>
  );
};

export default VendorTable;